import { auth } from '@/firebase';

const URL = 'https://api.meshcommengineering.com/api/v1';

class Charger {
    static async sendCommand(chargerId, command, payload, token = null) {
        const authToken = token || await auth.currentUser.getIdToken();
        const response = await fetch(`${URL}/charger/${chargerId}/command`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ command, payload }),
        });
        return response;
    }

    static async getConnected(token = null) {
        const authToken = token || await auth.currentUser.getIdToken();
        const response = await fetch(`${URL}/charger/connected`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });
        return response;
    }
}

export default Charger;
